import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Typography from '@digital-hig/mui/dist/Typography';
import { AutodeskGenericIcon } from '../common/utilities';

const TrialAcknowledgementPanel = ({ recentData, trialEntitlements }) => {
  const [recordData, setRecordData] = useState([]);
  useEffect(() => {
    recentData.forEach((record) => record.data?.then((res) => {
      setRecordData((prev) => ([
        ...prev, res,
      ]));
    }));
  }, []);

  const flattenArray = (arr) => {
    // Flatten the array
    const flattenedArray = arr.reduce((acc, val) => acc.concat(val), []);
    // Remove duplicates by converting it to a Set and back to an array
    return [...new Set(flattenedArray)];
  };

  const products = [];
  if (recordData && recordData.length) {
    recordData.forEach((item) => {
      // Records for retired courses don't return product meta data and cause failure
      const guids = item?.meta?.products?.map((prod) => prod.guid);
      if (guids && guids.length) {
        products.push(guids);
      }
    });
  }

  const guids = flattenArray(products);
  const entitlementsToDisplay = trialEntitlements && trialEntitlements?.filter((entitlement) => guids.includes(entitlement.guid));
  const hasActiveTrial = trialEntitlements?.filter((entitlement) => entitlement.active).length > 0;
  if (!entitlementsToDisplay.length || !hasActiveTrial) return null;
  return (
    <RootElement data-testid="trialAcknowlegePanel">
      <div>
        <Typography variant="headline-smaller">There’s more to explore!</Typography>
        <Typography variant="body-copy-small">Check out Autodesk learning to maximize your skills.</Typography>
      </div>
      <div className="trial-acknowledgement-panel-wrapper">
        {entitlementsToDisplay?.map((item, index) => {
          const isLessDaysRemaining = Object.keys(item).includes('remainingDays') && item?.remainingDays <= 7;
          const daysRemainingText = Object.keys(item).includes('remainingDays') ? `${item?.remainingDays} days remaining` : 'Expired';
          const isTrialExpired = Object.keys(item).includes('active') && !item?.active;
          return (
            <>
              <div className="trial-acknowledgement-panel">
                <div className="icon-title">
                  {item?.iconUrl && (<img src={item?.iconUrl} alt={item?.displayName} width="36" height="36" loading="lazy" />)}
                  {!item?.iconUrl && (<AutodeskGenericIcon />)}
                  <div className="title-days-remaining">
                    <Typography variant="headline-smallest">{item?.displayName}</Typography>
                    <Typography
                      color={isLessDaysRemaining || isTrialExpired ? 'ink-error' : ''}
                      variant={isLessDaysRemaining || isTrialExpired ? 'headline-smallest' : 'body-copy-small'}
                    >
                      {daysRemainingText}
                    </Typography>

                  </div>
                </div>
                {(isLessDaysRemaining || isTrialExpired) ? <Button variant="outlined" id="buy-now-button" size="small" data-wat-linkname={`Buy now ${item?.displayName}`} href={item?.buyUrl}>Buy now</Button> : null}
              </div>
              {entitlementsToDisplay?.length - 1 !== index ? <Divider orientation="horizontal" /> : null}
            </>
          );
        })}
      </div>
    </RootElement>
  );
};

const RootElement = styled.div`

  display: flex;
  padding: 0 24px;
  flex-direction: column;
  gap: 24px;
  min-width: 328px;

  .trial-acknowledgement-panel-wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .trial-acknowledgement-panel {
      display: flex;
      flex-direction: row;

      .icon-title {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 12px;
        min-width: 222px;

        .title-days-remaining {
          display: flex;
          flex-direction: column;
        }
      }

      #buy-now-button {
        margin-left: auto;
        align-self: flex-start;
      }

    }
  }

  @media only screen and (max-width:560px){
    padding: 0px;
  }
`;

TrialAcknowledgementPanel.propTypes = {
  recentData: PropTypes.oneOfType([PropTypes.array]).isRequired,
  trialEntitlements: PropTypes.oneOfType([PropTypes.array]).isRequired,
};

export default TrialAcknowledgementPanel;
